<template>
  <list-item
    :booking="booking"
    :link="{ name: 'bookings.show', params: { id: this.booking.id } }"
  >
    <template v-slot:categories>
      <div v-if="booking.opportunities.length" class="flex flex-wrap">
        <span v-for="app in booking.opportunities" :key="app.id" class="label label-info">{{ app.name }}</span>
      </div>
    </template>

    <template v-slot:status>
      <div class="spacer-b-2">
        <span class="label label-danger" v-if="bookingIsContextuallyCancelled">Cancelled</span>
        <span class="label label-success" v-else-if="bookingIsScheduled">Scheduled</span>
        <span class="label label-info" v-else-if="bookingIsOnHold">On Hold</span>
        <span class="label label-success" v-else-if="bookingIsBooked">Booked</span>
        <span class="label label-info" v-else-if="bookingIsCompleted">Completed</span>
        <span class="label label-danger" v-else-if="bookingHasExpired">Expired</span>
        <span class="label label-hidden" v-if="$userIsAdmin && bookingIsNotPublic">Hidden</span>
        <span class="label label-success" v-if="$paymentsModuleEnabled && userCanSeePaymentStatus && bookingPaymentFinalIsPaid"><i class="fa fa-check fa-fw"></i> Full Payment</span>
        <span class="label label-success" v-if="$vlastMode && $paymentsModuleEnabled && userCanSeePaymentStatus && bookingPaymentFullIsPaid"><i class="fa fa-check fa-fw"></i> Full Payment</span>
        <span class="label label-success" v-else-if="$paymentsModuleEnabled && userCanSeePaymentStatus && bookingPaymentDepositIsPaid"><i class="fa fa-check fa-fw"></i> Deposit Paid</span>
        <span class="label label-danger" v-else-if="$paymentsModuleEnabled && userCanSeePaymentStatus && bookingPaymentDepositIsUnpaid"><i class="fa fa-times fa-fw"></i> Deposit Unpaid</span>
        <span class="label label-danger" v-else-if="$paymentsModuleEnabled && userCanSeePaymentStatus && bookingPaymentDepositIsSent">Deposit Sent</span>
        <span class="label label-danger" v-if="$paymentsModuleEnabled && userCanSeePaymentStatus && bookingPaymentFinalIsSent">Final Sent</span>
        <span class="label label-danger" v-if="booking.urgent">Urgent</span>
      </div>
    </template>

    <template v-slot:hero v-if="userCanSeeBudget" >
      <template v-if="!booking.is_offer && ($userIsTalent || $userIsManager)">
        <template v-if="booking.local_currency">
          {{ booking.local_currency_budget_per_star_as_user_rate | abbreviatedCurrency(booking.local_currency) | nullable }}
        </template>
        <template v-else>
          {{ booking.budget_per_star_as_user_rate | abbreviatedCurrency(booking.currency) | nullable }}
        </template>
      </template>
      <span v-else-if="bookingGrandTotalBudget">{{ bookingGrandTotalBudget | abbreviatedCurrency(booking.local_currency ? booking.local_currency : booking.currency) | nullable }}</span>
      <span v-else>View</span>
    </template>

    <template v-slot:admin>
      <div class="spacer-b-1 flex flex-row" v-if="booking.local_currency">
        <i class="fa fa-info-circle spacer-r-1"></i>
        <span>Estimated conversion to {{ booking.local_currency }}. Actual amount may differ due to fluctuating conversion rates.</span>
      </div>
      <meta-item v-if="bookingIsNotPublic && $userIsAdmin" icon="eye-slash" class="text-danger">Hidden</meta-item>
      <meta-item v-if="bookingIsCompleted && $userIsAdmin">
        {{ bookingOnlineCompletionDate }}
      </meta-item>
    </template>
  </list-item>
</template>

<script>
import { helpers } from 'mixins/bookings'
import ListItem from '../list/ListItem'
import MetaItem from '../list/meta/MetaItem'

export default {
  mixins: [helpers],
  components: {
    ListItem,
    MetaItem
  },
  computed: {
    userCanSeePaymentStatus () {
      return this.$paymentsModuleEnabled && (this.$userIsAdmin || this.$userIsManager)
    }
  },

  props: {
    booking: {
      type: Object,
      required: true
    }
  }
}
</script>
